import { comparisonRows } from '../data/comparisonPageContent';

const ComparisonMatrix = () => (
  <div className="overflow-x-auto rounded-3xl border border-slate-800">
    <table className="min-w-[1100px] w-full text-left">
      <thead className="bg-slate-800 text-sm uppercase tracking-wider text-slate-300">
        <tr>
          <th className="p-5">Criteria</th>
          {['AutoReception', 'Smith.ai', 'My AI Front Desk', 'Dialpad', 'Slang.ai', 'Goodcall', 'Bland AI'].map((name) => <th key={name} className="p-5">{name}</th>)}
        </tr>
      </thead>
      <tbody className="divide-y divide-slate-800 bg-slate-900/80">
        {comparisonRows.map((row) => (
          <tr key={row[0]} className="text-sm text-slate-300">
            {row.map((cell, index) => <td key={`${row[0]}-${index}`} className={`p-5 ${index === 0 ? 'font-semibold text-white' : ''}`}>{cell}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default ComparisonMatrix;